import en from './en';
import fr from './fr';
import es from './es';
import de from './de';
import zh from './zh';
import ar from './ar';
import ja from './ja';
import ru from './ru';

const translations = {
  en,
  fr,
  es,
  de,
  zh,
  ar,
  ja,
  ru
};

export default translations; 